import React from 'react';
import { FaBug, FaCopyright, FaExclamationTriangle, FaWindowClose } from "react-icons/fa"; // npm i react-icons #see https://github.com/react-icons/react-icons
import { DEBUG_MODE, VERSION, RELEASE, AUTHOR, WEBSITE, SUPPORT } from "../../config";
import { AdtAccordion } from 'adt-widgets';
import versiondata from '../../../version.json';

function RedWarning() {
    return (
        <span className="w3-text-red" style={{ marginLeft: "6px" }} title="Warning">
            <FaExclamationTriangle />
        </span>
    );
}

/**
 * Represents an "À propos" message
 */
export function APropos({ auth }: PropsType) {
    const b2s = (b: boolean) => b?.toString() ?? "false";
    return (
        <div className="w3-modal-content w3-border w3-white" style={{ maxWidth: '30em' }}>
            <div className="w3-center">
                <h3 className="w3-panel w3-border w3-light-blue w3-margin">About Service Hub</h3>
                <div className="w3-border w3-border-blue" style={{ margin: 'auto', width: '20em' }}>
                    <div className="w3-row">
                        <div className="w3-half">Author: </div>
                        <div className="w3-half"><a href={WEBSITE} target="_blank" rel="noreferrer">{AUTHOR}</a></div>
                    </div>
                    <div className="w3-row">
                        <div className="w3-half">Version: </div>
                        <div className="w3-half">{VERSION}</div>
                    </div>
                    <div className="w3-row">
                        <div className="w3-half">Released on: </div>
                        <div className="w3-half">{RELEASE}</div>
                    </div>
                </div>
                <div className="w3-section">
                    <FaCopyright /> {new Date(versiondata?.version_date).getFullYear()} - All rights reserved
                </div>
                <hr />
                {auth &&
                    <div className="w3-container w3-margin-top">
                        <AdtAccordion title={"Client settings"}>
                            <div className="w3-text-gray w3-left-align">
                                extern=<code>{b2s(auth.extern)}</code><br />
                                user_2fa=<code>{b2s(auth.user_2fa)}</code> {!auth.user_2fa && <RedWarning />}<br />
                                debug=<code>{b2s(DEBUG_MODE)}</code> {DEBUG_MODE && <RedWarning />}<br />
                                jqx_theme=<code>{/*JQX_THEME*/}</code>
                            </div>
                        </AdtAccordion>
                    </div>}
            </div>

            <div className="w3-container w3-small">
                <AdtAccordion title={"Open Source Licenses"}>
                    <ul>
                        <li>
                            <a href="https://github.com/facebook/react" target="_blank" rel="noreferrer">
                                react</a>
                            , <a href="https://github.com/ReactTraining/react-router" target="_blank" rel="noreferrer">
                                react-router</a>
                            , <a href="https://github.com/axios/axios" target="_blank" rel="noreferrer">
                                axios</a>
                            , <a href="https://github.com/crypto-browserify/pbkdf2" target="_blank" rel="noreferrer">
                                pbkdf2</a>
                            , <a href="https://github.com/speakeasyjs/speakeasy" target="_blank" rel="noreferrer">
                                speakeasy</a>
                            , <a href="https://github.com/lannex/react-password-strength-bar" target="_blank" rel="noreferrer">
                                react-password-strength-bar</a>
                            , <a href="https://www.w3schools.com/w3css/default.asp" target="_blank" rel="noreferrer">
                                W3.CSS</a> &nbsp;
                            <a href="https://mit-license.org" target="_blank" rel="noreferrer"><em>MIT License</em></a>
                        </li>
                        <li>
                            <a href="http://www.famfamfam.com/lab/icons/silk" target="_blank" rel="noreferrer">
                                Silk icon theme</a> (Mark James) &nbsp;
                            <a href="http://creativecommons.org/licenses/by/2.5" target="_blank" rel="noreferrer">
                                <em>CC Attribution 2.5 License</em></a>
                        </li>
                        <li>
                            <a href="https://react-icons.github.io/react-icons/icons?name=fa" target="_blank" rel="noreferrer">
                                React icons | Font Awesome</a> &nbsp;
                            <a href="https://creativecommons.org/licenses/by/4.0" target="_blank" rel="noreferrer">
                                <em>CC BY 4.0 License</em></a>
                        </li>
                        {/* <li>
                  <a href="https://tweetnacl.js.org" target="_blank" rel="noreferrer">TweetNaCl.js</a> &nbsp;
                  <em>Public domain</em>
               </li> */}
                    </ul>
                </AdtAccordion>
                <p>
                    This application requires Javascript and sets a &#127850;Cookie.<br />
                    {auth && <>
                        To report <FaBug /> bugs, please contact the <a href={`mailto:${SUPPORT}`} rel="noreferrer">Auditum support</a>.
                    </>}
                </p>
            </div>

            <div className="w3-margin">
                <FaWindowClose /> <a href="#" onClick={() => window.top.close()}>Close</a>
            </div>
        </div>
    );
}

type PropsType = {
    auth: {
        extern;
        user_2fa;
    };
};
